import { Instance, applySnapshot, getSnapshot, types } from 'mobx-state-tree';
import theme, { getTheme } from 'theme';
import palette from 'theme/palette';
import getModalGradient from 'utils/getModalGradient';

export const paletteBackground = {
	concentration: '#F0F8FF',
	space:
		'linear-gradient(113.9deg, rgba(204, 245, 254, 0.8) 1.18%, rgba(252, 227, 254, 0.8) 98.58%)',
};

const Theme = types
	.model('Theme', {
		text: types.optional(types.string, palette.text.primary),
		primary: types.optional(types.string, palette.primary.main),
		background: types.optional(types.string, paletteBackground.concentration),
		backgroundImage: types.optional(types.string, ''),
		banner: types.optional(types.string, palette.banner),
		modalGradient: types.optional(types.array(types.string), [
			palette.modal.color1,
			palette.modal.color2,
		]),
	})
	.views((self) => ({
		get finalBackground() {
			const background = self.backgroundImage.startsWith('url')
				? self.backgroundImage
				: `url(${self.backgroundImage})`;

			return self.background === 'customImage'
				? {
						default: background,
					}
				: { default: self.background };
		},
	}))
	.views((self) => ({
		get theme() {
			const [color1, color2] = self.modalGradient;

			const result = getTheme({
				primary: {
					main: self.primary,
					contrastText: theme.palette.getContrastText(self.primary),
				},
				text: {
					primary: self.text,
				},
				background: self.finalBackground,
				modal: {
					color1,
					color2,
					modalGradient: getModalGradient(color1, color2),
				},
				banner: self.banner,
			});
			console.info('THEME', result);
			return result;
		},
	}))
	.actions((self) => ({
		set(data: any) {
			applySnapshot(self, data);
			localStorage.setItem('theme', JSON.stringify(getSnapshot(self)));
		},
		reset() {
			const resetPalette = {
				text: theme.palette.text.primary,
				primary: theme.palette.primary.main,
				background: paletteBackground.concentration,
				backgroundImage: '',
				banner: theme.palette.banner,
				modalGradient: [theme.palette.modal.color1, theme.palette.modal.color2],
			};
			applySnapshot(self, resetPalette);
			localStorage.removeItem('theme');
		},
	}));

export default Theme;

export interface IThemeModel extends Instance<typeof Theme> {}
